import { Component, ElementRef, OnInit, SimpleChanges, ViewChild } from "@angular/core";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { Router } from "@angular/router";
import { LocalStorageService } from 'angular-2-local-storage/dist/local-storage.service';
import { Modal } from "ngx-modal";
import { PaginationInstance } from 'ngx-pagination';
import { AccessLevel } from "../../../common/enums/access-level.enum";
import { Permission } from "../../../common/enums/permission.enum";
import { RowStatus } from "../../../common/enums/row-status.enum";
import { CacheKey } from "../../../shared/constants/cachekey.constants";
import { UserInfo } from "../../../shared/interface/user-info.interface";
import { CacheService } from "../../../shared/services/cache.service";
import { CommonService } from "../../../shared/services/common.service";
import { CommonMessage } from "../../common/common-messages";
import { OperatingCountryEnums } from "../../enums/countries.enums";
import { NotificationType } from "../../enums/notification-types.enum";
import { TicketTypeModel } from "../../interface/ticketingsystem/ticket-types-model";
import { DeleteModal } from "../../models/delete-modal";
import { CustomerService } from "../../services/customer.service";


@Component({
    selector: "ticketType-search",
    templateUrl: "../../templates/template1/views/configuration/ticketType-search.component.html",
    styleUrls:  ["../../templates/template1/themes/default/css/ticketSubType.less"]
})
export class TicketTypeSearch implements OnInit {

    ManageAdminPermissions: any[] = [Permission.MANAGE_DEPARTMENT_CREATE,Permission.MANAGE_DEPARTMENT_VIEW,Permission.MANAGE_DEPARTMENT_EDIT, Permission.MANAGE_DEPARTMENT_DEACTIVATE];
      
    @ViewChild('operCountry') operCountry: ElementRef;

    ticketTypeForm: FormGroup;
    operatingCountries: any[];
    ticketTypes:any = [];
    operatingCountry:number = this._localStorageService.get('ticketTypeOperatingCountry')? this._localStorageService.get('ticketTypeOperatingCountry') : 0;
    ticketType:string = this._localStorageService.get('ticketType')? this._localStorageService.get('ticketType') : "";
    isUpdate:boolean = false;
    ticketTypeId:number;
    message:string;
    activateDeactivatePopup:DeleteModal;
    typeId:number;
    activate:boolean;
    ticketTypeInfo:any;
    isSubmitted:boolean;
    userInfo: UserInfo;
    permission:any = Permission;
    clearPopup:DeleteModal;
    rowStatus:any=RowStatus;

     sortColumn:any ;
    sort: string = "DESC";

    pageNumber: number = this._localStorageService.get('ticketTypePageNumber')? this._localStorageService.get('ticketTypePageNumber') : 1;
    pageSize: number = 10;
    pageCount: number = 0;
    isDesc: boolean = true;

    createTypePermission: boolean;
    viewTypePermission:boolean;
    editTypePermission:boolean;
    deactivatePermission:boolean;
    isCountriesLoading = false;
   

    /**
     * Pagination instance - to avoid console warnings - inorder to assign id for pagination
     */
    public paginationInstance: PaginationInstance = {
        id: 'ticketTypes-pagination',
        itemsPerPage: 10,
        currentPage: 1
    };
     
     @ViewChild('createTicketModal') createTicketPopup: Modal;
     
    constructor(private router: Router, private _customerservice: CustomerService,
        private _commonService: CommonService,
        private _formbuilder: FormBuilder,private _cacheService: CacheService, private _localStorageService: LocalStorageService)
         {
    }
    ngOnInit(): void {
        
        this.setFocusToDropDown();
        this.getOperatingCountries();
        this.isDesc = false;
        this.getTicketTypesSearch();
        this.activateDeactivatePopup = new DeleteModal(this.activateOrDeactivateType.bind(this),
        this.doNotRemoveFormData.bind(this), this.doNotRemoveFormData.bind(this));
        this.activateDeactivatePopup.viewActionButtons = true;
        this.buildForm();
        this.userInfo = this._cacheService.get(CacheKey.UserInfo);
        
        this.createTypePermission = this._commonService.checkPermissionByAccessLevel(JSON.parse("[" + this.ManageAdminPermissions[0] + "]"),AccessLevel.Account); 
        this.viewTypePermission = this._commonService.checkPermissionByAccessLevel(JSON.parse("[" + this.ManageAdminPermissions[1] + "]"),AccessLevel.Account); 
        this.editTypePermission = this._commonService.checkPermissionByAccessLevel(JSON.parse("[" + this.ManageAdminPermissions[2] + "]"),AccessLevel.Account);
        this.deactivatePermission = this._commonService.checkPermissionByAccessLevel(JSON.parse("[" + this.ManageAdminPermissions[3] + "]"),AccessLevel.Account);

    }

     /**
     * sort table by respective column
     * @param sortColumn 
     */

    sortTableByColumn(sortColumn:string){
        this.isDesc = (this.sortColumn == sortColumn) ? !this.isDesc : this.isDesc;
        this.sort = this.isDesc ? "DESC" : "ASC";
        this.sortColumn = sortColumn;
        this.getTicketTypesSearch();

         //added this condition not to hit service if there are no items in grid.
        if (this.ticketTypes.length === 0) {
                    return;
             }
            this.getTicketTypesSearch();
        }
     /**
       * On Page change 
       * @param pageNumber 
       */
    pageChange(pageNumber: number) {
        if (!isNaN(pageNumber)) {
            this.pageNumber = pageNumber;
            this.isDesc = false;
        this.getTicketTypesSearch();
       }
    }

    ngOnChanges(changes: SimpleChanges) {  
        this.setFocusToDropDown();
     }

    setFocusToDropDown(){
        
        setTimeout(function(){           
            const autoFocusElement = document.getElementById("autofocus-element");
            if (autoFocusElement) {
                autoFocusElement.focus();
            }
         }, 200);
    }

    OnTabEventRecentlyViewed() {
        this.setFocusToDropDown();
    }

    getOperatingCountries() {
        this.isCountriesLoading = true;
        this._customerservice.getAllBusinessEntities().subscribe((response: any) => {
            if (response) {
                this.isCountriesLoading = false;
                this.operatingCountries = response;                
                let countryInfo = this.operatingCountries.find((country:any) =>  country.id === OperatingCountryEnums.USA);
                if(countryInfo){
                    this.operatingCountries.splice( this.operatingCountries.indexOf(countryInfo), 1 );
                    this.operatingCountries.splice(0, 0, countryInfo);
                }
            }
            
        },error => {
            this.isCountriesLoading = false;
        });
    }
    getTicketTypesSearch(){
       if(this.ticketType){
        this._localStorageService.set('ticketType',this.ticketType);
       }
       if(this.operatingCountry){
        this._localStorageService.set('ticketTypeOperatingCountry',this.operatingCountry);
       }
       this._localStorageService.set('ticketTypePageNumber',this.pageNumber);

        this._customerservice.getTicketTypesSearch(this.ticketType, this.operatingCountry, this.isDesc, this.sortColumn,this.pageNumber,this.pageSize).subscribe((response: any) => {
            if (response) {
                this.ticketTypes = response["content"];
                this.pageCount = response["totalCount"];
            }
            else{
                this.ticketTypes = [];
                this.pageCount = 0;
            }
        });
        
         
    }
    manageTicketSubtypes(ticketTypeId:number){
        this.router.navigate(['/customerservice/configuration/ticketsubtype/'+ticketTypeId]);
    }
    activateOrDeactivateType(){
        this._customerservice.activateOrDeactivateType(this.typeId, this.activate).subscribe((response: any) => {
            if (response) {
                if(this.activate){
                    this.message = "Ticket Type activated successfully.";
                }
                else{
                    this.message = "Ticket Type deactivated successfully.";
                }
                this._commonService.createNotification("", this.message, NotificationType.SUCCESS);
                this.getTicketTypesSearch();
            }
            else{
                this.message = "Ticket Subtype activate/deactivate failed.";
                this._commonService.createNotification("", this.message, NotificationType.ERROR);
            }
        });
    }
    doNotRemoveFormData() {
        //data should not be removed...
    }
    activateOrDeactivateAlert(typeId:number,activate:boolean){
        this.typeId =typeId;
        this.activate= activate;
        this.activateDeactivatePopup.toggle = true;
        if(activate){
            this.activateDeactivatePopup.message = CommonMessage.activateMessage;
        }
        else{
            this.activateDeactivatePopup.message = CommonMessage.deactivateMessage;
        }
    }

    opeCreateTicketModal() {         
       this.buildForm();
        if(this.isUpdate){
            this.isUpdate = false;
        }
                
        this.createTicketPopup.open();   
        setTimeout(function(){            
            const autoFocusElement = document.getElementById("autofocus-modal-element");
            if (autoFocusElement) {
                autoFocusElement.focus();
            }
         }, 200);   
         
      
    }
    closePopUp()
    {
    this.createTicketPopup.close();
    }
    buildForm() {
      
        this.ticketTypeForm = this._formbuilder.group({
            operatingCountryId: ['', Validators.required],
            ticketType: ['', Validators.required],
            ticketTypeStatus: [true]
        });
    }
    resetForm(){
        if(this.isUpdate){
            this.getTicketTypeInfo(this.ticketTypeId);
        }
        else{
            this.operatingCountry=0;
            this.ticketType='';
            this.ticketTypeForm.reset();
            this.buildForm();
        }
        
    }
    onSubmit(isValid : boolean){     
        this.isSubmitted = true;
        if(isValid){
            this.isSubmitted = false;
            let ticketTypeValues = this.ticketTypeForm.getRawValue();
            let ticketTypeReq= new TicketTypeModel();
            ticketTypeReq.value = ticketTypeValues.ticketType.trim();
            ticketTypeReq.operatingCountry = ticketTypeValues.operatingCountryId;
            let country= this.operatingCountries.find(item => item.id === +ticketTypeValues.operatingCountryId);
            country ? ticketTypeReq.operatingCountryName = country.name : null;
            ticketTypeReq.rowStatus = ticketTypeValues.ticketTypeStatus? RowStatus.Active:RowStatus.Inactive;
            if(!this.isUpdate){
                ticketTypeReq.createdBy = this.userInfo.userId;
            }
            else{
                ticketTypeReq.id=this.ticketTypeId; 
                ticketTypeReq.updatedBy = this.userInfo.userId;
            }
            this.isUpdate ? this.updateTicketType(ticketTypeReq):this.createTicketType(ticketTypeReq);
         }
        }
    editTicketTypeForm(ticketTypeId : any){    
        this.isUpdate =true;
        this.ticketTypeId = ticketTypeId;
        this.buildForm();
        this.getTicketTypeInfo(ticketTypeId);
        this.createTicketPopup.open();
        setTimeout(function(){              
            const element = document.getElementById("tkttypename-focus");
            if (element) {
                element.focus();
            }
         }, 200);
    }
    
    updateTicketType(ticketTypeReq:TicketTypeModel){
 
        this._customerservice.updateTicketType(ticketTypeReq).subscribe((response: any) => {
            if (response && response.validations.length === 0) {
                this.message = "Ticket Type updated successfully.";
                this._commonService.createNotification("", this.message, NotificationType.SUCCESS);
                this.isDesc = false;
                this.getTicketTypesSearch();
                this.createTicketPopup.close();
            }
            else if(response && response.validations.length > 0){
                this.message = response.validations[0].message;
                this._commonService.createNotification("", this.message, NotificationType.ERROR);
            }
            else{
                this.message = "Ticket Type creation failed.";
                this._commonService.createNotification("", this.message, NotificationType.ERROR);
            }
        });
    }
    createTicketType(ticketTypeReq:TicketTypeModel){
        this._customerservice.createTicketType(ticketTypeReq).subscribe((response: any) => {
            if (response && response.validations.length === 0) {
                this.message = "Ticket Type created successfully.";
                this._commonService.createNotification("", this.message, NotificationType.SUCCESS);
                this.isSubmitted = false;
                this.buildForm();
                this.isDesc = false;
                this.getTicketTypesSearch();
                this.createTicketPopup.close();                 
            }
            else if(response && response.validations.length > 0){
                this.message = response.validations[0].message;
                this._commonService.createNotification("", this.message, NotificationType.ERROR); 

                var backdropelement = document.getElementsByClassName('modal-backdrop')[0];
                backdropelement.classList.remove('in');
                setTimeout(() => {
                    backdropelement.classList.add('in');
                }, 3000);
            }
            else{
                this.message = "Ticket Type creation failed.";
                this._commonService.createNotification("", this.message, NotificationType.ERROR);
            }
        });
    }
    onSearch() {
        window.document.getElementById("search-button").classList.add('button-active');
        setTimeout(() => {
            window.document.getElementById("search-button").classList.remove('button-active');
          }, 1000);
        this.pageNumber = 1;
        this.getTicketTypesSearch();
        // this.getTicketTypeInfo(this.ticketTypeId);
    }

    clearFields(){
       this.setFocusToDropDown();
       this.operatingCountry=0;       
       this.ticketType='';
       this.pageNumber = 1;
       this.isDesc = false;
       this._localStorageService.remove('ticketType');
       this._localStorageService.remove('ticketTypeOperatingCountry');
       this._localStorageService.remove('ticketTypePageNumber');
       this.getTicketTypesSearch();
    }

    getTicketTypeInfo(ticketTypeId:any){
        this._customerservice.getTicketTypeInfo(ticketTypeId).subscribe((response: any) => {
            if (response) {
                this.ticketTypeInfo = response;
                this.ticketTypeForm.patchValue({
                    operatingCountryId: this.ticketTypeInfo.operatingCountry,
                    ticketType: this.ticketTypeInfo.value,
                    ticketTypeStatus : (this.ticketTypeInfo.rowStatus == RowStatus.Active) ?true:false
                })
            }
        });
    }
    clear(){
        this.clearPopup.toggle = true;
        this.clearPopup.message = CommonMessage.clearFormData;
    }
}


// WEBPACK FOOTER //
// ./src/app/customerservice/components/configuration/ticketType-search.compnent.ts